import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsule {
  AGE_CAPSULE = PageId.AGE_CAPSULE,
  URGE_CAPSULE = PageId.URGE_CAPSULE,
  HAIR_COLOR_CAPSULE = PageId.HAIR_COLOR_CAPSULE,
  EYES_COLOR_CAPSULE = PageId.EYES_COLOR_CAPSULE,
  JEWELRY_CAPSULE = PageId.JEWELRY_CAPSULE,
  BODY_SHAPE_CAPSULE = PageId.BODY_SHAPE_CAPSULE,
  OUTFIT_STRUGGLES_CAPSULE = PageId.OUTFIT_STRUGGLES_CAPSULE,
  STYLIO_TO_HELP_CAPSULE = PageId.STYLIO_TO_HELP_CAPSULE,
  TALL_CAPSULE = PageId.TALL_CAPSULE,
  WEIGHT_CAPSULE = PageId.WEIGHT_CAPSULE,
  BODY_COMFORT_CAPSULE = PageId.BODY_COMFORT_CAPSULE,
  WHAT_YOU_WEAR_CAPSULE = PageId.WHAT_YOU_WEAR_CAPSULE,
  URGE_2_CAPSULE = PageId.URGE_2_CAPSULE,
  SHOPPING_CAPSULE = PageId.SHOPPING_CAPSULE,
  STYLE_MOST_MATTERS_CAPSULE = PageId.STYLE_MOST_MATTERS_CAPSULE,
  YOUR_LOCATION_CAPSULE = PageId.YOUR_LOCATION_CAPSULE,
  FEEL_ABOUT_CAPSULE = PageId.FEEL_ABOUT_CAPSULE,
  WARDROBE_USAGE_CAPSULE = PageId.WARDROBE_USAGE_CAPSULE,
  NOT_ALONE_CAPSULE = PageId.NOT_ALONE_CAPSULE,
  PERCENTAGE_CAPSULE = PageId.PERCENTAGE_CAPSULE,
  FAVORITE_COLORS_CAPSULE = PageId.FAVORITE_COLORS_CAPSULE,
  LIKE_OR_DISLIKE_CAPSULE = PageId.LIKE_OR_DISLIKE_CAPSULE,
  LIKE_OR_DISLIKE_11_CAPSULE = PageId.LIKE_OR_DISLIKE_11_CAPSULE,
  LIKE_OR_DISLIKE_12_CAPSULE = PageId.LIKE_OR_DISLIKE_12_CAPSULE,
  LIKE_OR_DISLIKE_13_CAPSULE = PageId.LIKE_OR_DISLIKE_13_CAPSULE,
  LIKE_OR_DISLIKE_14_CAPSULE = PageId.LIKE_OR_DISLIKE_14_CAPSULE,
  LIKE_OR_DISLIKE_15_CAPSULE = PageId.LIKE_OR_DISLIKE_15_CAPSULE,
  LIKE_OR_DISLIKE_16_CAPSULE = PageId.LIKE_OR_DISLIKE_16_CAPSULE,
  LIKE_OR_DISLIKE_17_CAPSULE = PageId.LIKE_OR_DISLIKE_17_CAPSULE,
  LIKE_OR_DISLIKE_18_CAPSULE = PageId.LIKE_OR_DISLIKE_18_CAPSULE,
  LIKE_OR_DISLIKE_19_CAPSULE = PageId.LIKE_OR_DISLIKE_19_CAPSULE,
  SEE_YOURSELF_CAPSULE = PageId.SEE_YOURSELF_CAPSULE,
  STYLES_FEEL_LIKE_YOU_CAPSULE = PageId.STYLES_FEEL_LIKE_YOU_CAPSULE,
  URGE_4_CAPSULE = PageId.URGE_4_CAPSULE,
  WHAT_YOU_WILL_FIND_CAPSULE = PageId.WHAT_YOU_WILL_FIND_CAPSULE,
  BRAND_CAPSULE = PageId.BRAND_CAPSULE,
  FIND_NEW_CLOTHES_CAPSULE = PageId.FIND_NEW_CLOTHES_CAPSULE,
  NOTHING_TO_WEAR_CAPSULE = PageId.NOTHING_TO_WEAR_CAPSULE,
  OLD_CLOTHES_CAPSULE = PageId.OLD_CLOTHES_CAPSULE,
  COMBINE_CLOTHES_CAPSULE = PageId.COMBINE_CLOTHES_CAPSULE,
  OPTIMIZE_BUDGET_CAPSULE = PageId.OPTIMIZE_BUDGET_CAPSULE,
  URGE_3_CAPSULE = PageId.URGE_3_CAPSULE,
  PREPARE_FLOW_CAPSULE = PageId.PREPARE_FLOW_CAPSULE,
  EMAIL_CAPSULE = PageId.EMAIL_CAPSULE,
  EMAIL_CONSENT_CAPSULE = PageId.EMAIL_CONSENT_CAPSULE,
  SUBSCRIPTIONS_CAPSULE = PageId.SUBSCRIPTIONS_CAPSULE,
  CANCEL_OFFER_CAPSULE = PageId.CANCEL_OFFER_CAPSULE,
  SUB_UPSELL_CAPSULE = PageId.SUB_UPSELL_CAPSULE,
  UPSELL_CAPSULE = PageId.UPSELL_CAPSULE,
  THIRD_PDF_UPSELL_CAPSULE = PageId.THIRD_PDF_UPSELL_CAPSULE,
  BUNDLE_UPSELL_CAPSULE = PageId.BUNDLE_UPSELL_CAPSULE,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSULE = PageId.DOWNLOAD_CAPSULE,
}
